import { render, staticRenderFns } from "./PlayerDetail.vue?vue&type=template&id=3b706e52&scoped=true"
import script from "./PlayerDetail.vue?vue&type=script&lang=js"
export * from "./PlayerDetail.vue?vue&type=script&lang=js"
import style0 from "./PlayerDetail.vue?vue&type=style&index=0&id=3b706e52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b706e52",
  null
  
)

export default component.exports